import { render, staticRenderFns } from "./Informatives.vue?vue&type=template&id=29b3f45b&scoped=true"
import script from "./Informatives.vue?vue&type=script&lang=js"
export * from "./Informatives.vue?vue&type=script&lang=js"
import style0 from "./Informatives.vue?vue&type=style&index=0&id=29b3f45b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b3f45b",
  null
  
)

export default component.exports